"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOffer = exports.Offers = void 0;
var offers_1 = require("./offers");
Object.defineProperty(exports, "Offers", { enumerable: true, get: function () { return __importDefault(offers_1).default; } });
var useOffer_1 = require("./useOffer");
Object.defineProperty(exports, "useOffer", { enumerable: true, get: function () { return __importDefault(useOffer_1).default; } });
